export enum EValidationType {
  UNIQUE = 'UNIQUE',
  LENGTH = 'LENGTH',
  REQUIRED = 'REQUIRED',
}
